<template>
  <div class="store-locator__modal" v-if="visible">
    <div class="store-locator__modal--content">
      <button class="close" @click="close">
        Fermer <i class="fal fa-times"></i>
      </button>
      <div v-html="content"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'cp-modal',
  data() {
    return {
      visible: false,
    };
  },
  props: {
    content: String,
  },
  methods: {
    open() {
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
  },
  mounted() {
    this.trace('{modal.vue} mounted');
  },
};
</script>
